import { render } from "./WithLoader.vue?vue&type=template&id=639a939f&scoped=true&ts=true"
import script from "./WithLoader.vue?vue&type=script&lang=ts"
export * from "./WithLoader.vue?vue&type=script&lang=ts"

import "./WithLoader.vue?vue&type=style&index=0&id=639a939f&lang=stylus&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-639a939f"]])

export default __exports__